// Handleize option title to string
function handleize(str) {
    return str
        .toLowerCase()
        .replace(/[^\w\s-]/g, '-') // Remove special characters
        .replace(/\s+/g, '-')     // Replace spaces with hyphens
        //.replace(/-+/g, '-')     // Remove consecutive hyphens
        .replace(/-/g, '')
}

document.addEventListener('DOMContentLoaded', function() {
  // 1. Select all your inputs (adjust the selector to match your theme)
  const selectors = document.querySelectorAll('.variant-picker__form input, .variant-picker__form select');

  selectors.forEach(selector => {
    selector.addEventListener('change', () => {
      
      // 2. Get all currently selected values
      const selectedOptions = Array.from(selectors).map(el => {
        if (el.type === 'radio' || el.type === 'checkbox') {
          return el.checked ? el.value : null;
        }
        return el.value;
      }).filter(value => value !== null);

      // 3. Find the variant that matches these options
      const matchedVariant = productVariants.find(variant => {
        // This checks if the variant's options array matches our selectedOptions array
        return variant.options.every((option, index) => option === selectedOptions[index]);
      });

      // 4. Do something with the result
      if (matchedVariant) {
        console.log("Current Variant ID:", matchedVariant.id);
        // updatePage(matchedVariant);

        // dm - render selected variant's images
        console.log(matchedVariant.option1)

        const selectedVariantImages = document.querySelectorAll(`[class*="${handleize(matchedVariant.option1)}"]`);

        document.querySelectorAll('.dm-variant-images__image').forEach(item => {
          item.classList.add('dm-hide');
        });

        selectedVariantImages.forEach(item => {
          item.classList.remove('dm-hide');
        });

      } else {
        console.log("Variant not available");
      }
    });
  });
});

function updatePage(variant) {
  console.log("updatePage function exe")

  // Update Price
  const priceElement = document.querySelector('.price-item');
  if (priceElement) priceElement.innerText = Shopify.formatMoney(variant.price);

  // Update URL so the user can refresh the page
  const url = new URL(window.location);
  url.searchParams.set('variant', variant.id);
  window.history.replaceState({}, '', url);
}